var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TagType } from '~/Api/InfoCard/InfoCard';
export var ConditionType;
(function (ConditionType) {
    ConditionType["dateFrom"] = "year-month-from";
    ConditionType["dateTo"] = "year-month-to";
})(ConditionType || (ConditionType = {}));
export var conditionKey = function (condition) { return "".concat(condition.type, ":").concat(condition.value); };
var Filter = /** @class */ (function () {
    function Filter(conditions) {
        var _this = this;
        this.conditionsSet = new Set();
        this.conditions = conditions.filter(function (condition) {
            var key = conditionKey(condition);
            if (_this.conditionsSet.has(key)) {
                return false;
            }
            _this.conditionsSet.add(key);
            return true;
        });
    }
    Object.defineProperty(Filter.prototype, "searchParams", {
        get: function () {
            var filters = this.conditions.reduce(function (filters, condition) {
                var values = filters.get(condition.type);
                if (values !== undefined) {
                    values.push(condition.value);
                }
                else {
                    filters.set(condition.type, [condition.value]);
                }
                return filters;
            }, new Map());
            return new URLSearchParams(Array.from(filters.entries()).map(function (_a) {
                var type = _a[0], values = _a[1];
                return [
                    type === TagType.type ? 'filter-type' : "filter-".concat(type),
                    values.join(','),
                ];
            }));
        },
        enumerable: false,
        configurable: true
    });
    Filter.prototype.added = function (condition) {
        if (condition.type === TagType.yearMonth) {
            return this.toggle({ type: ConditionType.dateFrom, value: condition.value }).toggle({
                type: ConditionType.dateTo,
                value: condition.value,
            });
        }
        if (condition.type === TagType.brand || condition.type === TagType.type) {
            return new Filter(__spreadArray(__spreadArray([], this.conditions, true), [condition], false));
        }
        if (condition.type === TagType.source) {
            var final = this.conditions.filter(function (otherCondition) { return otherCondition.type !== condition.type; });
            return new Filter(__spreadArray(__spreadArray([], final.filter(function (otherCondition) { return otherCondition.sourceId !== condition.value; }), true), [condition], false));
        }
        return new Filter(__spreadArray(__spreadArray([], this.conditions.filter(function (otherCondition) { return otherCondition.type !== condition.type; }), true), [
            condition,
        ], false));
    };
    Filter.prototype.has = function (condition) {
        return this.conditionsSet.has(conditionKey(condition));
    };
    Filter.prototype.keep = function (conditions, type) {
        var filtered = this.conditions.filter(function (otherCondition) { return type !== otherCondition.type; });
        return new Filter(__spreadArray(__spreadArray([], conditions, true), filtered, true));
    };
    Filter.prototype.removed = function (condition) {
        if (condition.type === TagType.brand || condition.type === TagType.type) {
            var conditions_1 = this.conditions.filter(function (otherCondition) { return condition.value !== otherCondition.value; });
            return new Filter(conditions_1);
        }
        var conditions = this.conditions.filter(function (otherCondition) { return condition.type !== otherCondition.type && condition.value !== otherCondition.value; });
        return new Filter(conditions);
    };
    Filter.prototype.toggle = function (condition) {
        var conditions = this.conditions.filter(function (otherCondition) { return otherCondition.type !== condition.type; });
        if (condition.value !== '') {
            conditions.push(condition);
        }
        return new Filter(conditions);
    };
    return Filter;
}());
export { Filter };
